import React from "react";
import { toast, } from 'react-toastify';
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { fetchData } from '../../utils/handleApi'
import { Link } from 'react-router-dom'

const validEmailRegex = RegExp(
/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i
);
class LoginPage extends React.Component {

  state = {
    cardAnimaton: "cardHidden",
    email: "",
    password: "",
    errors: {
      email: "",
      password: ""
    },
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "email":
        errors.email = validEmailRegex.test(value) ? "" : "Email is not valid!";
        break;
      case "password":
        errors.password =
          value.length < 5
            ? "Password must be at least 5 characters long!"
            : "";
        break;
      default:
        break;
    }
    this.setState({ errors, [name]: value });
  };

  validateError = () => {
    let hasError = false;
    const { errors } = this.state;

    errors.email = validEmailRegex.test(this.state.email) ? "" : "Email is not valid!";

    errors.password =
      this.state.password.length < 6
        ? "Password must be at least 6 characters long!"
        : "";

    this.setState({ errors });
    for (const value of Object.values(errors)) {
      if (value.length > 0)
        hasError = true
      else
        hasError = false
    }
    return hasError;
  }


  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validateError()) {
      return toast.error('Form Validation Error')
    } else {
      fetchData('admin/login', 'post', {
        email_id: this.state.email.toLowerCase(),
        password: this.state.password,
      })
      .then(data => {
        if(data.err){
          if(data.err.data.message === "Not found"){
            return toast.error('Email doesn\'t exists!')
          }
          if(data.err.data.message === "Incorrect Password"){
            return toast.error('Please enter valid login credentials!')
          }
        }
        localStorage.setItem("admin_data", JSON.stringify(data.details));
        localStorage.setItem("admin_token", data.token);
        window.location.reload();
        this.props.history.push("/admin/vendors");
      })
    }    
  }

  disableSpacebar = (e) => {
    if(e.keyCode === 32){
        e.preventDefault();
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form noValidate onSubmit={this.handleSubmit}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="success"
                >
                  <h4 className={classes.cardTitle}>Log in</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Email..."
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name: "email",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: this.handleChange,
                      onKeyDown: (e) => this.disableSpacebar(e)
                    }}
                  />
                  {this.state.errors.email && <p style={{color: "red", margin: 0, fontSize: "12px"}}>{this.state.errors.email}</p>}
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      type: "password",
                      onChange: this.handleChange,
                      onKeyDown: (e) => this.disableSpacebar(e)
                    }}
                  />
                  {this.state.errors.password && <p style={{color: "red", margin: 0, fontSize: "12px"}}>{this.state.errors.password}</p>}
                  <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Link to="/auth/forgot-page" style={{margin: 0, fontSize: "12px", color: "#333",}}>Forgot Password?</Link>
                  </div>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button type="submit" color="success" simple size="lg" block style={{color: "#fff", backgroundColor: "#4caf50"}}>
                    LOGIN
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(LoginPage);
